import {
  GET_SMS_TEMPLATE_LOADING,
  GET_SMS_TEMPLATE_ERROR,
  GET_SMS_TEMPLATE_INFO,
  GET_EMAIL_TEMPLATE_LOADING,
  GET_EMAIL_TEMPLATE_ERROR,
  GET_EMAILTEMPLATE_INFO,
} from "../constants";

const initial_state = {
  loading: {
    templates: false,
  },
  errors: {
    // templates: "Error message"
  },

  ecsSmsTemplates: [], // List of available templates
  ecsEmailTemplates: [], // List of available templates
};

export default function (state = initial_state, { type, payload }) {
  const loading = state.loading;

  switch (type) {
    case GET_SMS_TEMPLATE_ERROR:
      return {
        ...state,
        errors: payload || { unknown: "Unknown error" },
      };

    case GET_EMAIL_TEMPLATE_ERROR:
      return {
        ...state,
        errors: payload || { unknown: "Unknown error" },
      };

    case GET_SMS_TEMPLATE_LOADING:
      loading[payload] = true;
      return {
        ...state,
        loading,
      };

    case GET_EMAIL_TEMPLATE_LOADING:
      loading[payload] = true;
      return {
        ...state,
        loading,
      };

    case GET_SMS_TEMPLATE_INFO:
      loading.ecsSmsData = false;

      return {
        ...state,
        loading,
        ecsSmsTemplates: payload,
      };

    case GET_EMAILTEMPLATE_INFO:
      loading.ecsEmailData = false;

      return {
        ...state,
        loading,
        ecsEmailTemplates: payload,
      };

    default:
      return state;
  }
}
